export default "__VITE_PUBLIC_ASSET__d88f169b__"